// 转换超图数据数组到GeoJSON FeatureCollection
export function supermapArrayToGeoJSON(supermapArray) {
    return {
        type: "FeatureCollection",
        features: supermapArray.map(item => supermapToFeature(item))
    };
}

// 转换单个超图要素到GeoJSON Feature
function supermapToFeature(supermapData) {
    return {
        type: "Feature",
        id: supermapData.ID || supermapData.id,
        properties: convertProperties(supermapData),
        geometry: convertSupermapGeometry(supermapData.geometry)
    };
}

// 转换属性字段
function convertProperties(supermapData) {
    const properties = {};
    
    // 如果已经有字段名和字段值的分离结构
    if (supermapData.fieldNames && supermapData.fieldValues) {
        supermapData.fieldNames.forEach((fieldName, index) => {
            properties[fieldName] = supermapData.fieldValues[index];
        });
    }
    
    // 如果有额外的属性可以直接合并
    if (supermapData.properties) {
        Object.assign(properties, supermapData.properties);
    }
    
    return properties;
}

// 转换几何对象（处理多种类型）
function convertSupermapGeometry(supermapGeom) {
    if (!supermapGeom) return null;
    
    const { type, points = [], parts = [], point2Ds = [] } = supermapGeom;
    
    // 处理面数据（REGION）
    if (type === "REGION" || type === "REGION3D") {
        if (!points.length) return { type: "MultiPolygon", coordinates: [] };
        
        const coordinates = [];
        let startIndex = 0;
        
        // 如果有parts数组，说明是多部分面
        if (parts && parts.length > 0) {
            for (const partCount of parts) {
                const partPoints = points.slice(startIndex, startIndex + partCount);
                const ring = partPoints.map(p => [p.x, p.y]);
                // 确保环是闭合的（第一个点和最后一个点相同）
                if (ring.length > 0 && (ring[0][0] !== ring[ring.length-1][0] || ring[0][1] !== ring[ring.length-1][1])) {
                    ring.push([ring[0][0], ring[0][1]]);
                }
                coordinates.push([ring]);
                startIndex += partCount;
            }
        } else {
            // 单部分面
            const ring = points.map(p => [p.x, p.y]);
            if (ring.length > 0 && (ring[0][0] !== ring[ring.length-1][0] || ring[0][1] !== ring[ring.length-1][1])) {
                ring.push([ring[0][0], ring[0][1]]);
            }
            coordinates.push([ring]);
        }
        
        return {
            type: "MultiPolygon",
            coordinates: coordinates
        };
    }
    
    // 处理线数据（LINE）
    else if (type === "LINE" || type === "LINE3D") {
        const coordinates = [];
        let startIndex = 0;
        
        if (parts && parts.length > 0) {
            for (const partCount of parts) {
                const partPoints = points.slice(startIndex, startIndex + partCount);
                coordinates.push(partPoints.map(p => [p.x, p.y]));
                startIndex += partCount;
            }
        } else {
            coordinates.push(points.map(p => [p.x, p.y]));
        }
        
        return coordinates.length > 1 ? {
            type: "MultiLineString",
            coordinates: coordinates
        } : {
            type: "LineString",
            coordinates: coordinates[0]
        };
    }
    
    // 处理点数据（POINT）
    else if (type === "POINT" || type === "POINT3D") {
        if (points.length === 1) {
            return {
                type: "Point",
                coordinates: [points[0].x, points[0].y]
            };
        } else if (points.length > 1) {
            return {
                type: "MultiPoint",
                coordinates: points.map(p => [p.x, p.y])
            };
        } else if (supermapGeom.x && supermapGeom.y) {
            return {
                type: "Point",
                coordinates: [supermapGeom.x, supermapGeom.y]
            };
        }
    }
    
    // 处理超图的其他几何格式（如point2Ds）
    else if (point2Ds && point2Ds.length > 0) {
        return {
            type: "MultiPoint",
            coordinates: point2Ds.map(p => [p.x, p.y])
        };
    }
    
    // 默认返回null几何
    return null;
}
